var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/travis/build/SouthAmericansSecrets/web/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["partials/article-sidebar.es.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"banner-right floating-right\">\n  <a href=\"packagecoast.html#package-mystery-south-coast\" class=\"ad\">\n    <div class=\"title\">\n      Líneas de Nazca & Costa Sur\n      <div class=\"gallery autoplay items-1\">\n        <div id=\"item-1\" class=\"control-operator\"></div>\n        <figure class=\"item\">\n            <div class=\"banner-img nazca-lines\">\n            </div>\n        </figure>\n      </div>\n      <div class=\"tour-info-title\">2 días / 1 noche</div>\n      <div class=\"tour-info-title\"><h4>$565.00 USD</h4></div>\n      <div class=\"tour-info-title\">Por persona desde Lima transporte & hotel incluídos</div>\n      <p style=\"font-size:14px;\">\n        <b>¿No tiene mucho tiempo disponible?</b> Disfrute de unas vacaciones enteras con <b>tranquilidad, comfort &amp; y estilo</b>:<br>\n        Vuele sobre las líneas de Nazca, con un tour guíado por la Reserva Nacional de Paracas, excursiones a las Islas Ballestas, visite el viñedo en Ica, visite el oasis Huacachina y disfrute de un emocionante paseo en un vehículo rustico a través de la duna. <br> El coste también incluye *todo* transporte, transfers, y ¡gastos! Desde tu hotel en Lima.\n      </p>\n    </div>\n  </a>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["partials/article-sidebar.es.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./app/tpl/partials/article-sidebar.es.njk
// module id = 52
// module chunks = 50 51 52 53 57 58 59 60 61 62 63 64